
import { getAllProvidersByPracticeId, getNotificationList, searchPracticeOrProvider } from 'api';
import { detectMob } from 'components';
import { detectMobileApp } from 'shared/utils/detectDevice';
import NativeBridge from 'shared/utils/NativeBridge';

/** 
 * Bug#425 : Service for search 
 * @Author: Linda Susan Raju 
 * @Date: 05 July 2021
 */
const isMobile = detectMob();
const isMobileApplication = detectMobileApp();

const searchService = (dispatchItemData, pageNo, props, pageSize) => {
    if (props.type === 'PRACTICE_DOCTOR_LIST') {
        searchByPracticeId(props, dispatchItemData, pageNo, pageSize);
    } else if (props.type === 'PRACTICE_OR_PROVIDER_LIST') {
        searchPracticeOrProviderList(props, dispatchItemData, pageNo, pageSize);
    }
}

const searchByPracticeId = (props, dispatchItemData, pageNo, pageSize) => { 
    /*Bug #790 -add a loader in the search list area while searching for a physician, clinic, or hospital - added by Aby on Mar30-2022 */   
    if(pageNo === 0)
    {
       dispatchItemData(paginationContext => ({ ...paginationContext, loader: true}));
    }
    /*Bug #790 - end */
    getAllProvidersByPracticeId(props.practiceId, pageNo, pageSize).then(resp => {
        isMobile ?
            dispatchItemData(paginationContext => ({ ...paginationContext, items: pageNo !== 0 ? [...paginationContext.items, ...resp.data.list] : resp.data.list, loader: false, totalItemCount: resp.data.totalCount }))
            :
            dispatchItemData(paginationContext => ({ ...paginationContext, items: resp.data.list, loader: false, totalItemCount: resp.data.totalCount }));
    }).catch(error => {
        console.error(error);
    })
}

const searchPracticeOrProviderList = (props, dispatchItemData, pageNo, pageSize) => { 
    /*Bug #790 -add a loader in the search list area while searching for a physician, clinic, or hospital - added by Aby on Mar30-2022 */   
    if(pageNo === 0)
    {
        dispatchItemData(paginationContext => ({ ...paginationContext, loader: true}));
    }
    /*Bug #790 - end */
    searchPracticeOrProvider(props.filter, pageNo, pageSize).then(resp => {
        isMobile ?
            dispatchItemData(paginationContext => ({ ...paginationContext, items: pageNo !== 0 ? [...paginationContext.items, ...resp.data.list] : resp.data.list, loader: false, totalItemCount: resp.data.totalCount }))
            :
            dispatchItemData(paginationContext => ({ ...paginationContext, items: resp.data.list, loader: false, totalItemCount: resp.data.totalCount }));
        if (isMobileApplication) { NativeBridge.call('searchResult', { success: resp.data.success }); }
    }).catch(error => {
        if (isMobileApplication) { NativeBridge.call('searchResult', { success: false, errorMessage: error }); }
        console.error(error);
    })
}



export default searchService;
/**End Bug#425 */